import { buiDashboardEndPointLogic } from "../../../../../../../logic/AssetManagement/overview/BusinessLeaderDashboard/buiDashboardEndPointLogic";

const loadedFromTotalQueryId = "5675729136123904";
const gapQueryId = "5664969639067648";
const trafficSourceQueryId = "5691256340480000";
const platformIDQueryId = "5671985870798848";
const LateConversionsQueryId = "5763288017141760";
const loadingFailuresQueryId = "5724539828830208";
const platformIdentifiersQueryId = "5730364475572224";
const uploadedToPlatformsQueryId = "5638246889422848";
const advertisingPlatformsQueryId = "5718125026738176";
const incentivizedTrafficQueryId = "5728315943944192";
interface Data {
  sharedUid: any;
  dimension: any;
  type: any;
  all: any;
  startDate: any;
  endDate: any;
  authToken: string;
  trackPromise: any;
  selectedActionType: string;
}

const getLoadingPercentageDetails = (
  data: Data,
  queryId: string,
  setData: any
) => {
  return buiDashboardEndPointLogic.getBuiDashboardData_loadedFromTotal(
    data?.authToken as string,
    data?.sharedUid,
    queryId,
    data?.trackPromise,
    setData,
    data?.dimension,
    data?.type,
    data?.all,
    data?.startDate,
    data?.endDate,
    data?.selectedActionType
  );
};

export async function getAllDataForLoadedFromTotal(
  sharedUid: any,
  dimension: any,
  type: any,
  all: any,
  startDate: any,
  endDate: any,
  authToken: any,
  trackPromise: any,
  setLoadedFromTotal: any,
  setGapBrandData: any,
  setTrafficSourceData: any,
  setIncentivizedTrafficData: any,
  setPlatformIDdata: any,
  setLateConversionsData: any,
  setLoadingFailuresData: any,
  setPlatformIdentifiersData: any,
  setUploadedToPlatformsData: any,
  setAdvertisingPlatformsData: any,
  selectedActionType: string,
  setIsFTDPageLoading: any
) {
  const data: Data = {
    sharedUid: sharedUid,
    dimension: dimension,
    type: type,
    all: all,
    startDate: startDate,
    endDate: endDate,
    authToken: authToken,
    trackPromise: trackPromise,
    selectedActionType: selectedActionType,
  };
  setIsFTDPageLoading(true);

  try {
    await Promise.all([
      getLoadingPercentageDetails(
        data,
        loadedFromTotalQueryId,
        setLoadedFromTotal
      ),
      getLoadingPercentageDetails(data, gapQueryId, setGapBrandData),
      getLoadingPercentageDetails(
        data,
        trafficSourceQueryId,
        setTrafficSourceData
      ),
      getLoadingPercentageDetails(data, platformIDQueryId, setPlatformIDdata),
      getLoadingPercentageDetails(
        data,
        LateConversionsQueryId,
        setLateConversionsData
      ),
      getLoadingPercentageDetails(
        data,
        loadingFailuresQueryId,
        setLoadingFailuresData
      ),
      getLoadingPercentageDetails(
        data,
        platformIdentifiersQueryId,
        setPlatformIdentifiersData
      ),
      getLoadingPercentageDetails(
        data,
        uploadedToPlatformsQueryId,
        setUploadedToPlatformsData
      ),
      getLoadingPercentageDetails(
        data,
        advertisingPlatformsQueryId,
        setAdvertisingPlatformsData
      ),
      getLoadingPercentageDetails(
        data,
        incentivizedTrafficQueryId,
        setIncentivizedTrafficData
      ),
    ]);
  } finally {
    setIsFTDPageLoading(false);
  }
}
